import React, { Component } from 'react';
import CircularProgress from 'components/mouldifi-components/CircularProgress';

export default class LoaderContainer extends Component {
  render() {
    //To Do: Replace this with the actual component from pages when its done
    return <CircularProgress />;
  }
}
